module.exports = __webpack_public_path__ + "static/kscope_preview-9bed27cc61e33db963266ecd4cb2c787.jpg";